import React from 'react';
import { useState } from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';
import axios from 'axios';
import { useEffect } from 'react';
import ItemShow from '../../components/Form/ItemShow';
import { Loading } from '../../components/Loading';

const CatalogueShow = () => {
      const { catalogueId } = useParams();
      const [catalogue, setCatalogue] = useState([]);
      const [loadingData, setLoadingData] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const loadCategories = async () => {
            setLoadingData(true);

            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/catalogues/${catalogueId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setCatalogue(response.data.catalogue);
                        }
                  })
                  .catch((error) => {
                        console.log(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadCategories();
      }, []);

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader>
                                          <CardTitle>
                                                Catalogue Details
                                          </CardTitle>
                                          <CardLinks>
                                                <LinkButton to="/dashboard/catalogues">
                                                      Back
                                                </LinkButton>
                                          </CardLinks>
                                    </CardHeader>
                                    <Card.Body>
                                          {!loadingData ? (
                                                <Row>
                                                      <Col lg={6}>
                                                            <img
                                                                  className="w-100"
                                                                  src={
                                                                        catalogue.image
                                                                  }
                                                                  alt=""
                                                            />
                                                            <div className="px-3 ">
                                                                  <div>
                                                                        <div
                                                                              dangerouslySetInnerHTML={{
                                                                                    __html: catalogue.summary
                                                                              }}
                                                                        ></div>
                                                                  </div>
                                                            </div>
                                                      </Col>
                                                      <Col lg={6}>
                                                            <ListGroup>
                                                                  <ItemShow
                                                                        title=" Title"
                                                                        value={
                                                                              catalogue.title
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Type"
                                                                        value={
                                                                              catalogue.type
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Date"
                                                                        value={
                                                                              catalogue.date
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="By"
                                                                        value={
                                                                              catalogue.user_name
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Seo Title"
                                                                        value={
                                                                              catalogue.seo_title
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Seo Keyword"
                                                                        value={
                                                                              catalogue.seo_keyword
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Seo Description"
                                                                        value={
                                                                              catalogue.seo_description
                                                                        }
                                                                  />
                                                            </ListGroup>
                                                      </Col>
                                                </Row>
                                          ) : (
                                                <>
                                                      <div
                                                            className="text-center d-flex align-items-center justify-content-center w-100"
                                                            style={{
                                                                  height: '30vh'
                                                            }}
                                                      >
                                                            <Loading />
                                                      </div>
                                                </>
                                          )}
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default CatalogueShow;
